import React from "react";

function Home() {
  return (
    <div className="page-container">
      {/* Header image */}
      <img
        src="./home/Home_header.png"
        alt="RTA 995 | MP 8995"
        className="header-img"
      />

      <h1 className="year-header">Winter 2026</h1>

      {/* 2x2 responsive grid */}
      <div className="square-photos">
        <img src="./home/GeoTEAM.jpg" alt="GeoTEAM" className="grid-img" />
        <img src="./home/MeTrA.jpg" alt="MeTrA" className="grid-img" />
        <img src="./home/SnapToEat.jpg" alt="SnapToEat" className="grid-img" />
        <img src="./home/Hydrone.jpg" alt="Hydrone" className="grid-img" />
      </div>

      {/* About section */}
      <h1 className="section-header">About the course:</h1>
      <p>
        Few digital technologies make use of the connection between our bodies
        and minds to support creativity and knowledge production. This research
        and design-centered course provides students with the unique
        opportunity to envision the shape of research-based education in digital
        and embodied media, while working in the Synaesthetic Media Lab (Synlab)
        on cutting-edge projects in Tangible and Embodied Interaction for
        creativity, discovery, and expression.
      </p>
    </div>
  );
}

export default Home;
